import { createFileRoute } from "@tanstack/react-router";
import { FeedReferenceSend } from "../../app/views/alsSend";

export const Route = createFileRoute("/feed/send")({
  component: FeedReferenceSend,
});
